import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { deleteData, getData, imgUrl } from '../Services/api';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';

const ProductMasterList = () => {
    const [products, setProducts] = useState([]);
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(false);

    const handleDownloadSample = async () => {
        try {
            setLoading(true);
            const token = localStorage.getItem('token');
            const res = await fetch(`${imgUrl}api/v1/product-master/download-sample`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (!res.ok) throw new Error('Failed to download sample file');

            const blob = await res.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = 'Product_Master_Sample.xlsx';
            link.click();
            window.URL.revokeObjectURL(url);
            toast.success('Sample file downloaded successfully');
        } catch (error) {
            console.error('Download sample error:', error);
            toast.error('Failed to download sample file');
        } finally {
            setLoading(false);
        }
    };

    const fetchProducts = async (searchQuery = "") => {
        setLoading(true);
        try {
            const endpoint = searchQuery ? `/product-master?search=${encodeURIComponent(searchQuery)}` : '/product-master';
            const res = await getData(endpoint);
            if (res.status) {
                setProducts(res.data || [])
            }
        } catch (error) {
            console.log("error fetch products", error)
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchProducts();
    }, []);

    const handleSearch = (e) => {
        e.preventDefault();
        fetchProducts(search);
    }

    const handleDelete = (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "No, cancel!",
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const res = await deleteData(`/product-master/delete/${id}`);
                    if (res.status) {
                        toast.success(res.message);
                        fetchProducts(search);
                    }
                } catch (error) {
                    console.log("error delete product", error)
                }
            }
        });
    }

    return (
        <>
            <div className="pc-container">
                <div className="pc-content">
                    <div className="page-header">
                        <div className="page-block">
                            <div className="row align-items-center">
                                <div className="col-md-12">
                                    <ul className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link to="/">Home</Link>
                                        </li>
                                        <li className="breadcrumb-item">
                                            <Link to="/product-master/product-list">Product Master</Link>
                                        </li>
                                        <li className="breadcrumb-item" aria-current="page">
                                            Product Master
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-md-12">
                                    <div className="page-header-title">
                                        <h2 className="mb-0">Product Master</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card table-card">
                                <div className="p-4 pb-sm-2 d-flex justify-content-between align-items-center flex-wrap gap-2">
                                    <form className="d-flex" onSubmit={handleSearch}>
                                        <input
                                            type="text"
                                            className="form-control me-2"
                                            placeholder="Search by name or code..."
                                            value={search}
                                            onChange={(e) => setSearch(e.target.value)}
                                            style={{ maxWidth: '300px' }}
                                        />
                                        <button className="btn btn-primary" type="submit" disabled={loading}>
                                            {loading ? 'Searching...' : 'Search'}
                                        </button>
                                    </form>
                                        <input
                                            type="file"
                                            accept=".xlsx, .xls"
                                            id="excelUpload"
                                            style={{ display: 'none' }}
                                            onChange={async (e) => {
                                                const file = e.target.files[0];
                                                if (!file) return;

                                                const formData = new FormData();
                                                formData.append('file', file);

                                                setLoading(true);
                                                try {
                                                    const { postData } = await import('../Services/api');
                                                    const data = await postData('/product-master/upload-excel', formData);
                                                    if (data.status) {
                                                        toast.success(data.message || 'Upload successful');
                                                        fetchProducts(search);
                                                    } else {
                                                        toast.error(data.message || 'Upload failed');
                                                    }
                                                } catch (error) {
                                                    toast.error('Upload failed. Please try again.');
                                                } finally {
                                                    setLoading(false);
                                                    e.target.value = null; // reset file input
                                                }
                                            }}
                                        />
                                        <button 
                                            className="btn btn-success d-inline-flex align-items-center me-2"
                                            onClick={() => document.getElementById('excelUpload').click()}
                                            disabled={loading}
                                        >
                                            <i className="fas fa-file-excel f-18 mx-2" /> Upload Excel
                                        </button>
                                        <button 
                                            className="btn btn-info text-white d-inline-flex align-items-center me-2"
                                            onClick={handleDownloadSample}
                                            disabled={loading}
                                        >
                                            <i className="fas fa-download f-18 mx-2" /> Download Sample
                                        </button>
                                        <Link to="/product-master/add-product"
                                            className="btn btn-primary d-inline-flex align-items-center"
                                        >
                                            <i className="fas fa-plus f-18 mx-2" /> Add Product
                                        </Link>
                                </div>
                                <div className="card-body">
                                    <div className="table-responsive">
                                        <table className="table table-hover" id="pc-dt-simple">
                                            <thead>
                                                <tr>
                                                    <th>S.No.</th>
                                                    <th>Product Name</th>
                                                    <th>Product Code</th>
                                                    <th>Packing Unit</th>
                                                    <th>Status</th>
                                                    <th className="text-center">Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    products?.length > 0 ? (
                                                        products?.map((product, index) => {
                                                            return (
                                                                <tr key={product.id}>
                                                                    <td>{index + 1}.</td>
                                                                    <td>
                                                                        <h6 className="mb-0">{product.product_name}</h6>
                                                                    </td>
                                                                    <td>{product.product_code}</td>
                                                                    <td>{product.packing_unit}</td>
                                                                    <td>
                                                                        <span className={`badge ${product.is_active ? 'bg-success' : 'bg-danger'}`}>
                                                                            {product.is_active ? 'Active' : 'Inactive'}
                                                                        </span>
                                                                    </td>
                                                                    <td className="text-center">
                                                                        <ul className="list-inline me-auto mb-0">
                                                                            <li
                                                                                className="list-inline-item align-bottom"
                                                                                data-bs-toggle="tooltip"
                                                                                title="Edit"
                                                                            >
                                                                                <Link
                                                                                    to={`/product-master/update-product/${product.id}`}
                                                                                    className="avtar avtar-xs btn-link-success btn-pc-default"
                                                                                >
                                                                                    <i className="fas fa-edit f-18" />
                                                                                </Link>
                                                                            </li>
                                                                            <li
                                                                                className="list-inline-item align-bottom"
                                                                                data-bs-toggle="tooltip"
                                                                                title="Delete"
                                                                            >
                                                                                <button
                                                                                    onClick={() => handleDelete(product.id)}
                                                                                    className="avtar avtar-xs btn-link-secondary btn-pc-default"
                                                                                >
                                                                                    <i className="fas fa-trash f-18" />
                                                                                </button>
                                                                            </li>
                                                                        </ul>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })
                                                    ) : (
                                                        <tr>
                                                            <td className='text-center' colSpan={6}><strong>No Data Found.</strong></td>
                                                        </tr>
                                                    )
                                                }

                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ProductMasterList
